import css from '@styled-system/css';

const base = css({
  overflow: 'hidden',
  position: 'relative',
  justifyContent: 'center',
  alignItems: 'center',
  height: 2,
  width: 4,
  borderRadius: 7,
  backgroundColor: 'neutral.40',
});

export default base;
